<ng-container *ngrxLet="productWidgetRestricted$ as isProductWidgetRestricted">
    @if (!isProductWidgetRestricted) {
        <div class="mb-20">
            @if (isCatalogOption) {
                <sp-control-handle
                    [controlHandleBtn]="false"
                    [controlHandleMainText]="element.value.name"
                    [controlHandleSubText]="subText"
                    [controlHandleImagePreviewSources]="previewImageUrls"
                    (removeActionEvent)="removeProduct()"
                    (catalogActionEvent)="openCatalogEvent.emit()"
                >
                </sp-control-handle>
            } @else {
                <sp-control-handle
                    [controlHandleBtn]="false"
                    [controlHandleMainText]="element.value.name"
                    [controlHandleSubText]="subText"
                    [controlHandleImagePreviewSources]="previewImageUrls"
                    (editActionEvent)="editProductCard.emit()"
                    (removeActionEvent)="removeProduct()"
                >
                </sp-control-handle>
            }
        </div>
    }
    @if (!isProductWidgetRestricted) {
        <div class="mb-20">
            <label>{{ "widget_product_card_type" | translate }}</label>
            <select class="form-control" [formControl]="cardViewType" (change)="changeViewType()">
                @for (option of cardTypeOptions; track option) {
                    <option [ngValue]="option.value" [selected]="option.value === cardViewType.value">
                        {{ option.key | translate }}
                    </option>
                }
            </select>
            @if (isModalCardView) {
                <a class="dotted d-inline-block mt-5" (click)="setCurrentSettingsType.emit(settingEnum.MODAL)">{{
                    "widget_product_modal_settings" | translate
                }}</a>
            }
        </div>
    }
    @if (isOpenCardView) {
        <div class="mb-20">
            <label>{{ "widget_product_card_view" | translate }}</label>
            <a class="dotted pull-right" (click)="setCurrentSettingsType.emit(settingEnum.CARD)">{{
                "widget_product_settings" | translate
            }}</a>
            <div class="appearance-wrapper">
                @for (icon of productViewCardIcons; track icon) {
                    <div
                        (click)="setCardKindViewType(icon.value)"
                        [class.active]="cardKindViewType.value === icon.value"
                        class="appearance-block view"
                    >
                        <img [src]="icon.src" [alt]="icon.alt" />
                    </div>
                }
            </div>
        </div>
    }

    @if (isModalCardView) {
        <div class="mb-20">
            <label> {{ "control_card_preview" | translate }} </label>
            <a class="dotted pull-right" (click)="setCurrentSettingsType.emit(settingEnum.PREVIEW)">
                {{ "widget_product_settings" | translate }}
            </a>
            <div class="appearance-wrapper">
                <div
                    class="appearance-block"
                    [class.active]="cardModalViewType.value === viewModalType.vertical"
                    [tooltip]="vertical"
                    (click)="setModalView(viewModalType.vertical)"
                >
                    <img src="./assets/img/websites/lpc-product-view-vertical.svg" alt="vertical" />
                    <ng-template #vertical>
                        {{ "control_card_vertical_tooltip" | translate }}
                    </ng-template>
                </div>
                <div
                    class="appearance-block"
                    [class.active]="cardModalViewType.value === viewModalType.horizontal"
                    [tooltip]="horizontal"
                    (click)="setModalView(viewModalType.horizontal)"
                >
                    <img src="./assets/img/websites/lpc-product-view-horizontal.svg" alt="horizontal" />
                    <ng-template #horizontal>
                        {{ "control_card_horizontal_tooltip" | translate }}
                    </ng-template>
                </div>
            </div>
        </div>
    }

    <div [ngClass]="{ 'mb-20': isModalCardView && isVerticalPreview }">
        <label>{{ "widget_product_buttons" | translate }}</label>
        <sp-control-handle
            [controlHandleMainText]="buttonLabel.value"
            (editActionEvent)="setCurrentSettingsType.emit(settingEnum.BUTTON)"
            [controlHandleSubText]="isModalCardView ? ('widget_product_basket_sub_label' | translate) : ''"
        ></sp-control-handle>
        @if (isModalCardView) {
            <sp-control-handle
                [controlHandleCheckbox]="isModalCardView"
                [controlHandleCheckboxChecked]="isShowButton.value"
                [controlHandleSubText]="'widget_product_show_more_sub_label' | translate"
                [controlHandleMainText]="showMoreButton.controls.label.value"
                (editActionEvent)="setCurrentSettingsType.emit(settingEnum.SHOW_MORE_BUTTON)"
                (toggleCheckBoxEvent)="setIsShowButton($event)"
            ></sp-control-handle>
        }
    </div>

    @if (isModalCardView && isVerticalPreview) {
        <div>
            <div class="form-group form-horizontal row">
                <label class="control-label col-xs-6">
                    {{ "control_position" | translate }}
                </label>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="previewHorizontalPosition.value"
                        [type]="ERadioGroupType.horizontalPosition"
                        (changeSelectedEvent)="setPreviewHorizontalPosition($event)"
                    ></sp-radio-group>
                </div>
            </div>
        </div>
    }
    <div class="mt-20">
        <web-custom-id
            [displayId]="displayId"
            [disabled]="isProductWidgetRestricted"
            (valueChangeEvent)="updateWidgetDisplayId.emit($event)"
        >
        </web-custom-id>
    </div>
</ng-container>
